<template>
  <div class="design-width content">
      <video
      class="intro__video"
      src="/404.mp4"
      autoplay 
      loop="true"
      muted
      playsinline
    ></video>
    <div class="intro__caption">
    <h1 class="t-hero">404<br />Ups, Niemandsland.</h1>
    <p class="t-hero t-hero--small">Fly back <a href="/">here</a></p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { pageTitle } from '../js/meta';

// Netlify serves unknown URLs with HTTP 200 (SPA fallback), so keep them out of the index.
export default defineComponent({
  metaInfo: {
    title: pageTitle('404'),
    meta: [{ vmid: 'robots', name: 'robots', content: 'noindex' }],
  },
});
</script>

<style scoped>
  .intro__video {
    position: fixed;
  }

  .intro__caption {
    position: fixed;
    z-index: 20;
    bottom: 2rem;
    left: 2rem;
    color: var(--c-brand);
  }
</style>
